<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <div style="display: contents">
      <h4 class="mb-sm-0 pt-2">
        <span>FIA Applications</span>
      </h4>
    </div>
  </mdb-card-body>
</mdb-card>

<mdb-card class="mb-4 wow fadeIn">
  <!-- Card header -->
  <div class="card-header">
    <form class="d-flex md-form justify-content-center my-0 float-right">
      <button mdbBtn color="trakly-action" size="sm" class="my-0 p" (click)="ShowModal('userFiaApplicationModal')">
        <!-- <mdb-icon fas icon="money-bill-wave"></mdb-icon> Request a Trade -->
        New Application
      </button>
    </form>
  </div>
  <mdb-card-body class="d-sm-flex justify-content-between">
    <!--Error Display-->
    <div class="w-100" *ngIf="showError">
      <div class="alert alert-danger text-center font-weight-bold" role="alert">
        {{ errorMsg }}
      </div>
    </div>
    <!--Main Body-->
    <table mdbTable class="table-responsive" hover="true" small="true" responsive="true" *ngIf="!busy && userFiaApplcations?.length > 0">
      <thead>
        <tr>
          <th scope="col" class="col-2">Status</th>
          <th scope="col" class="col-1">Case Number</th>
          <th scope="col" class="col-1">Date Requested</th>
          <th scope="col" class="col-1">Requested Fia Amount</th>
          <th scope="col" class="col-2">Planned Investment Date</th>
          <th scope="col" class="col-1">Pin</th>
          <th scope="col" class="col-1">Pin Issue Date</th>
          <th scope="col" class="col-1">Pin Expiry Date</th>
        </tr>
      </thead>
      <tbody>
        <tr mdbTableCol *ngFor="let apps of userFiaApplcations">
          <td class="align-middle" *ngIf="apps.status == 1">Pending</td>
          <td class="align-middle" *ngIf="apps.status == 2">Awaiting Relevant Material</td>
          <td class="align-middle" *ngIf="apps.status == 3">Review In Progress</td>
          <td class="align-middle" *ngIf="apps.status == 4">Approved</td>
          <td class="align-middle" *ngIf="apps.status == 5">Declined</td>
          <td class="align-middle" *ngIf="apps.status == 6">Expired</td>
          <td class="align-middle" *ngIf="apps.status == 7">Complaint</td>
          <td class="align-middle" *ngIf="apps.status == 8">Cancelled</td>
          <td class="align-middle" *ngIf="apps.status == 9">Deleted</td>
          <td class="align-middle" *ngIf="!apps.status">Scheduled</td>

          <td class="align-middle" *ngIf="apps.caseNumber">
            {{ apps.caseNumber }}
          </td>
          <td class="align-middle" *ngIf="!apps.caseNumber">-</td>

          <td class="align-middle" *ngIf="apps.dateRequested">
            {{ apps.dateRequested | date }}
          </td>
          <td class="align-middle" *ngIf="!apps.dateRequested">-</td>

          <td class="align-middle">
            {{ apps.requestedFiaAmount | currency: "ZAR" : "symbol-narrow" }}
          </td>
          <td class="align-middle">{{ apps.plannedInvestmentDate | date }}</td>
          <td class="align-middle" *ngIf="apps.pin">{{ apps.pin }}</td>
          <td class="align-middle" *ngIf="!apps.pin">-</td>
          <td class="align-middle" *ngIf="apps.pin">
            {{ apps.pinIssueDate | date }}
          </td>
          <td class="align-middle text-center" *ngIf="!apps.pin">-</td>
          <td class="align-middle" *ngIf="apps.pin">
            {{ apps.pinExpiryDate | date }}
          </td>
          <td class="align-middle text-center" *ngIf="!apps.pin">-</td>
        </tr>
      </tbody>
    </table>

    <div class="w-100 text-center" *ngIf="!busy && userFiaApplcations?.length == 0">
      <img src="../../../../assets/img/Processing.svg" class="col-sm-4 mx-auto d-block" alt="1" />
      <h2 class="text-center">We didn't find any FIA applications...</h2>
      <p>We'll show the details of each FIA pin application here as soon as we have one.</p>
    </div>
    <!--Loading-->
    <div *ngIf="busy" class="col-12 text-center">
      <app-loading [busy]="busy"></app-loading>
    </div>
  </mdb-card-body>
</mdb-card>

<!-- User Fia Application Modal -->
<div
  mdbModal
  #userFiaApplicationModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="this.HideModal()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - FIA Application</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!modalBusy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="modalShowError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ modalErrorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">New FIA Application</p>
          </div>
          <!-- FIA Amount -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="newFia.fiaAmount"
              mdbInput
              mdbValidate
              name="fiaAmount"
              type="number"
              id="fiaAmount"
              class="form-control"
              #fiaAmount="ngModel"
              required
            />
            <label for="fiaAmount">FIA Amount</label>
            <mdb-error *ngIf="fiaAmount.invalid && (fiaAmount.dirty || fiaAmount.touched)">FIA Amount is required </mdb-error>
            <mdb-success *ngIf="fiaAmount.valid && (fiaAmount.dirty || fiaAmount.touched)"></mdb-success>
          </div>
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Supporting Documentation</p>
          </div>
          <!--Main Body-->
          <div class="selection-item-full">
            <div class="dropzone" filedropzone="">
              <div class="text-wrapper">
                <i class="fas fa-upload"></i>
                <p class="hidden-sm-down">
                  <a class="is-link"><strong>Browse</strong></a> to select files from your computer
                </p>
                <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
              </div>
              <input
                class="hidden w-100 h-100"
                type="file"
                multiple="multiple"
                #file
                (change)="onFileChange($event)"
                name="fileUploadArea"
              />
            </div>
          </div>

          <div class="d-block col-12" *ngIf="userNewDocuments?.length > 0">
            <p class="font-weight-bold mb-1">New Documents</p>
          </div>
          <table class="col-12" mdbTable *ngIf="userNewDocuments?.length > 0" hover="true" small="true" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-4">File Name</th>
                <th scope="col" class="col-6">Type</th>
                <th scope="col" class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let docs of userNewDocuments">
                <td class="align-middle">{{ docs.fileName }}</td>
                <td class="align-middle">
                  <select
                    class="form-control"
                    [(ngModel)]="docs.fileType"
                    placeholder="Select document type"
                    name="fileType"
                    style="display: block !important"
                  >
                    <option ngValue="Loan Agreement">Loan</option>
                    <option ngValue="Proof Of Source">Savings/Cash</option>
                    <option ngValue="Other">Other</option>
                  </select>
                </td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(docs.fileName)" mdbWavesEffect>Remove</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--Loading-->
        <div *ngIf="modalBusy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button *ngIf="modalBusy == false" type="button" mdbBtn class="relative waves-light btn-trakly" (click)="startOver()">
          Start Over
        </button>
        <button
          *ngIf="!modalBusy"
          type="button"
          mdbBtn
          color="trakly-action"
          class="relative waves-light"
          (click)="fiaApplicationApplyClicked()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
